<template>
  <layout :hide-side-bar="hideSideBar" :hide-top-nav="hideTopNav">
    <div v-if="sessionLoading" class="loader">
      <b-spinner label="Spinning" />
    </div>
    <template v-else>
      <div
        :class="{
          'main-container--shrinked': sidebarActive,
          'main-container': !sidebarActive,
          'no-sidebar': hideSideBar,
        }"
      >
        <router-view />
      </div>
    </template>
  </layout>
</template>

<script>
import { mapGetters } from 'vuex';
import Layout from './layouts/Default.vue';

export default {
  name: 'App',
  components: {
    Layout,
  },
  computed: {
    ...mapGetters('session', [
      'sidebarActive',
      'filterPage',
      'hubAdmin',
      'kitchenAdmin',
      'sessionLoading',
      'isMobile',
    ]),
    hideSideBar() {
      return Boolean(this.$route.meta.hideSideBar);
    },
    hideTopNav() {
      return Boolean(this.$route.meta.hideTopNav);
    },
  },
  watch: {
    $route(to) {
      this.setMetaData(to);
      this.updateFilterPage();
      this.toggleSidebarIfMobile();
    },
  },
  created() {
    this.updateFilterPage();
    this.setMetaData(this.$route);
    window.addEventListener('resize', this.onResize, { passive: true });
    this.onResize();
    if (this.$route.meta.collapseSideBar) {
      this.$store.dispatch('session/hideSidebar');
    }
    this.toggleSidebarIfMobile();

    // Handling init site visit
    this.sendGtagData();
  },
  updated() {
    // Handling route updates
    this.sendGtagData();
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true });
    }
  },
  methods: {
    toggleSidebarIfMobile() {
      if (this.isMobile && this.sidebarActive) {
        this.$store.dispatch('session/toggleSidebar');
      }
    },
    onResize() {
      this.$store.commit('session/updateIsMobile', window.innerWidth < 768);
    },
    sendGtagData() {
      this.$gtag.pageview(this.$route.fullPath);
    },
    // Update meta data on route change
    setMetaData(to) {
      document.title =
        to && to.meta.title ? `${to.meta.title} | Zuul Portal` : 'Zuul Portal';
    },
    updateFilterPage() {
      // Check if route has related prop
      if (this.$route.meta.related) {
        // clear filter and update filter page if this is first visited route or filter page doesn't match with related prop
        if (!this.filterPage || this.filterPage !== this.$route.meta.related) {
          this.$store.dispatch('session/resetFilters');
          this.$store.dispatch(
            'session/updateFilterPage',
            this.$route.meta.related
          );
        }
      } else {
        this.$store.dispatch('session/resetFilters');
      }
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css" />
